/**
 * Íconos del rediseño de Biblioteca (20.H) — port 1:1 del bundle del diseñador
 * (biblioteca-shared.jsx). Trazo 1.8 redondeado; set propio para juegos, decks
 * y estados. Fuente: claude-design/orborix-speak/biblioteca-redesign/.
 */
import type { ReactNode } from 'react';

interface IcProps {
  size?: number;
  fill?: string;
}

function libSvg(size: number, children: ReactNode, sw = 1.8) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
  );
}

export const LibIcSearch = ({ size = 18 }: IcProps) => libSvg(size, <><circle cx="11" cy="11" r="6.5" /><path d="M16 16 L 20.5 20.5" /></>);
export const LibIcClose = ({ size = 14 }: IcProps) => libSvg(size, <path d="M6 6 L 18 18 M 18 6 L 6 18" />, 2);
export const LibIcChevR = ({ size = 14 }: IcProps) => libSvg(size, <path d="M9 5 L 16 12 L 9 19" />);
export const LibIcChevD = ({ size = 14 }: IcProps) => libSvg(size, <path d="M5 9 L 12 16 L 19 9" />);
export const LibIcBookmark = ({ size = 16, fill = 'none' }: IcProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={fill} stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round" strokeLinecap="round">
    <path d="M6 4 H 18 a 1 1 0 0 1 1 1 V 20 L 12 16 L 5 20 V 5 a 1 1 0 0 1 1 -1 Z" />
  </svg>
);
// `tick`: el color de la tilde. Lleno (`fill="currentColor"`) y sin él, la
// tilde toma el color del círculo y no se ve.
export const LibIcCheckC = ({ size = 16, fill = 'none', tick }: IcProps & { tick?: string }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={fill} stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round">
    <circle cx="12" cy="12" r="9" /><path d="M8 12.5 L 11 15.5 L 16.5 9" {...(tick ? { stroke: tick } : {})} />
  </svg>
);
export const LibIcCheck = ({ size = 16 }: IcProps) => libSvg(size, <path d="M5 12.5 L 10 17.5 L 19 7" />, 2.2);
export const LibIcLayers = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M12 3 L 21 8 L 12 13 L 3 8 Z" /><path d="M3 13 L 12 18 L 21 13" /></>);
export const LibIcSpeaker = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M4 9 V 15 H 8 L 13 19 V 5 L 8 9 Z" /><path d="M16.5 8.5 a 5 5 0 0 1 0 7" /></>);
export const LibIcMic = ({ size = 30 }: IcProps) => libSvg(size, <><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11 a 6.5 6.5 0 0 0 13 0" /><path d="M12 17.5 V 21" /></>);
export const LibIcStar = ({ size = 14, fill = 'none' }: IcProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={fill} stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
    <path d="M12 3.5 L 14.6 9 L 20.5 9.8 L 16.2 14 L 17.2 20 L 12 17.1 L 6.8 20 L 7.8 14 L 3.5 9.8 L 9.4 9 Z" />
  </svg>
);
export const LibIcDots = ({ size = 18 }: IcProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor"><circle cx="5" cy="12" r="1.8" /><circle cx="12" cy="12" r="1.8" /><circle cx="19" cy="12" r="1.8" /></svg>
);
export const LibIcFilter = ({ size = 14 }: IcProps) => libSvg(size, <path d="M4 6 H 20 M 7 12 H 17 M 10 18 H 14" />);
export const LibIcTag = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M4 4 H 11 L 20 13 L 13 20 L 4 11 Z" /><circle cx="8.5" cy="8.5" r="1.4" /></>);
export const LibIcPencil = ({ size = 15 }: IcProps) => libSvg(size, <path d="M4 20 L 4.8 16.5 L 16 5.3 a 1.8 1.8 0 0 1 2.6 0 l 0.1 0.1 a 1.8 1.8 0 0 1 0 2.6 L 7.5 19.2 Z" />);
export const LibIcDownload = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M12 4 V 15 M 7 11 L 12 15.5 L 17 11" /><path d="M5 19.5 H 19" /></>);
export const LibIcPlay = ({ size = 14 }: IcProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor"><path d="M7 4.8 L 19 12 L 7 19.2 Z" /></svg>
);
export const LibIcArrowR = ({ size = 15 }: IcProps) => libSvg(size, <path d="M4 12 H 19 M 13 6 L 19.5 12 L 13 18" />, 2);
export const LibIcRetry = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M4.5 9 a 8 8 0 1 1 -0.6 5.5" /><path d="M4 4.5 V 9.5 H 9" /></>);
export const LibIcTrash = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M4 7 H 20" /><path d="M9 7 V 5 a 1 1 0 0 1 1 -1 H 14 a 1 1 0 0 1 1 1 V 7" /><path d="M6 7 L 7 19.5 a 1.5 1.5 0 0 0 1.5 1.5 H 15.5 a 1.5 1.5 0 0 0 1.5 -1.5 L 18 7" /></>);

// ─── Juegos ───────────────────────────────────────────────────────────
export const LibIcCards = ({ size = 18 }: IcProps) => libSvg(size, <><rect x="7" y="5" width="13" height="16" rx="2.2" /><path d="M4.5 17.5 L 3.2 6 a 2 2 0 0 1 1.7 -2.2 L 9 3.3" opacity="0.7" /><path d="M11 10 H 16.5" /></>);
export const LibIcPairs = ({ size = 18 }: IcProps) => libSvg(size, <><rect x="3" y="4" width="8" height="7" rx="2" /><rect x="13" y="13" width="8" height="7" rx="2" /><path d="M13 7.5 h 5.5 a 2.5 2.5 0 0 1 2.5 2.5 v 0.5 M 11 16.5 H 5.5 A 2.5 2.5 0 0 1 3 14 v -0.5" opacity="0.7" /></>);
export const LibIcGap = ({ size = 18 }: IcProps) => libSvg(size, <><path d="M4 7 H 20" opacity="0.55" /><path d="M4 12 H 8.5 M 15.5 12 H 20" /><path d="M10 14.5 H 14" strokeDasharray="2.5 2.5" /><path d="M4 17 H 16" opacity="0.55" /></>);
export const LibIcSay = ({ size = 18 }: IcProps) => libSvg(size, <><rect x="8" y="3.5" width="5" height="8.5" rx="2.5" /><path d="M5.5 9.5 a 5 5 0 0 0 10 0" /><path d="M10.5 16 V 18.5" /><path d="M17 5.5 a 5.5 5.5 0 0 1 0 7" opacity="0.8" /><path d="M19.5 3.5 a 9 9 0 0 1 0 11" opacity="0.45" /></>);
export const LibIcWave = ({ size = 18 }: IcProps) => libSvg(size, <path d="M3.5 12 c 1.5 0 1.5 -4 3 -4 s 1.5 7 3 7 s 1.5 -10 3 -10 s 1.5 9 3 9 s 1.5 -6 3 -6 s 1 4 2 4" />);

// ─── Decks ────────────────────────────────────────────────────────────
export const LibIcWeak = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M12 4 c 3.5 4 5.5 6.8 5.5 9.5 a 5.5 5.5 0 0 1 -11 0 C 6.5 10.8 8.5 8 12 4 Z" /><path d="M9.5 14.5 a 2.5 2.5 0 0 0 2 2.3" opacity="0.7" /></>);
export const LibIcFrost = ({ size = 15 }: IcProps) => libSvg(size, <path d="M12 4 V 20 M 6.8 7 L 17.2 17 M 17.2 7 L 6.8 17 M 12 4 l -2 2 m 2 -2 l 2 2 M 12 20 l -2 -2 m 2 2 l 2 -2" />, 1.6);
export const LibIcFlag = ({ size = 15 }: IcProps) => libSvg(size, <><path d="M6 21 V 4" /><path d="M6 5 H 17 L 14.5 8.5 L 17 12 H 6" /></>);
export const LibIcChat = ({ size = 15 }: IcProps) => libSvg(size, <path d="M4 6 a 2 2 0 0 1 2 -2 h 12 a 2 2 0 0 1 2 2 v 9 a 2 2 0 0 1 -2 2 H 10 l -4.5 3.5 V 17 H 6 a 2 2 0 0 1 -2 -2 Z" />);

export type LibDeckIconName = 'saved' | 'weak' | 'frost' | 'flag' | 'chat' | 'wave' | 'star' | 'cards';
export type LibGameIconName = 'cards' | 'pairs' | 'gap' | 'say' | 'wave';

export function libDeckIcon(name: LibDeckIconName, size = 15) {
  if (name === 'saved') return <LibIcBookmark size={size} />;
  if (name === 'weak') return <LibIcWeak size={size} />;
  if (name === 'frost') return <LibIcFrost size={size} />;
  if (name === 'flag') return <LibIcFlag size={size} />;
  if (name === 'chat') return <LibIcChat size={size} />;
  if (name === 'wave') return <LibIcWave size={size} />;
  if (name === 'star') return <LibIcStar size={size} />;
  return <LibIcCards size={size} />;
}

export function libGameIcon(name: LibGameIconName, size = 18) {
  if (name === 'pairs') return <LibIcPairs size={size} />;
  if (name === 'gap') return <LibIcGap size={size} />;
  if (name === 'say') return <LibIcSay size={size} />;
  if (name === 'wave') return <LibIcWave size={size} />;
  return <LibIcCards size={size} />;
}

export { libSvg };
